import { render, staticRenderFns } from "./TrainingDialogTabs.vue?vue&type=template&id=4233f4bb&"
import script from "./TrainingDialogTabs.vue?vue&type=script&lang=js&"
export * from "./TrainingDialogTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports